export default "__VITE_ASSET__TOUnf60h__"